import React, { useState, useEffect, useCallback } from 'react';
import { throttle } from 'underscore';
import { get, set } from 'bv-local-storage';
import BalanceView from './balance_view';

const {
  refresh,
  get: getBalance,
  subscribe,
  unsubscribe,
} = window.AccountBalance;

export default () => {
  const [showBalance, setShowBalance] = useState(!get('hide_balance'));
  const [refreshing, setRefreshing] = useState(false);
  const [balance, setBalance] = useState();

  // Throttle refresh balance
  const refreshBalance = useCallback(
    throttle(() => {
      setRefreshing(true);

      refresh().then(() => { setRefreshing(false); });
    }, 10000, { trailing: false }),
    [],
  );

  // Effect to get balance initially and subscribe to balance changes
  useEffect(() => {
    getBalance().then(setBalance);
    subscribe(setBalance);

    return () => { unsubscribe(setBalance); };
  }, []);

  const setShowBalanceWithLS = (show) => {
    setShowBalance(show);
    set('hide_balance', !show);
  };

  if (!balance) return null;

  return (
    <BalanceView
      showBalance={showBalance}
      setShowBalance={setShowBalanceWithLS}
      refreshing={refreshing}
      refreshBalance={refreshBalance}
      balance={balance}
    />
  );
};
